"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import ChatInterface from "@/components/chat/ChatInterface"
import { useAuth } from "@/hooks/useAuth"
import { GlobalContextProvider } from "@/app/context/GlobalContext"
import { LOCAL_AGENT } from "@/lib/localDev"
import { LoginScreen } from "@/components/auth/LoginScreen"

export default function ChatPage() {
  const { isAuthenticated, signIn } = useAuth()

  // Local mode: no Cognito login — render the chat directly. (AutoSignin is
  // also bypassed; this is the second, independent gate.)
  if (!isAuthenticated && !LOCAL_AGENT) {
    return <LoginScreen onSignIn={() => signIn()} />
  }

  return (
    <GlobalContextProvider>
      <div className="relative h-screen">
        <ChatInterface />
      </div>
    </GlobalContextProvider>
  )
}
